export default {
	hrv_preload_error:
		"Failed to obtain the image set. Please check your network and try again.",
	hrv_title_key: "Airdoc Stress Resilience Assessment",
  hrv_handle: "Processing, please do not click repeatedly",
  hrv_generate_title_key:
		"The AIRDOC Stress Resilience report is being generated",
	hrv_test_tip1_key: "Please remain seated",
	hrv_test_tip2_key: "Take a deep breath",
	hrv_test_tip3_key: "The test is about to begin",
	hrv_test_hook_device_load_key: "Device self-check",
	hrv_test_hook_modal_load_key: "Eye movement model loading",
	hrv_test_hook_testset_load_key: "Test batch loading",
	hrv_test_hook_environment_load_key: "Network check",
	hrv_test_hook_distance_load_key: "Distance check",
	hrv_test_hook_finger_load_key: "Collector check",
	hrv_test_hook_without_token_key:
		"User information has expired, please log in again",
	hrv_test_hook_network_good_key:
		"Network speed is good, proceeding with distance check.",
	hrv_test_hook_network_bad_key:
		"Network speed is too low, please check your network connection.",
	hrv_test_imagebox_tip_key: "Please look at the image",
	hrv_finished_backbtn_key: "Back",
	hrv_finished_title_key: "Stress Resilience Assessment",
	hrv_finished_network_error_key:
		"Data upload failed. Please check your network and try again",
	hrv_finished_submit_error_key:
		"The collected data is invalid. Please retake the test",
	hrv_finished_unknown_error_key:
		"Unknown error. Please contact customer support",
	hrv_finished_reupload_key: "Re-upload",
	hrv_finished_redetect_key: "Retake Test",
	hrv_finished_quit_test_key: "Are you sure you want to quit this test?",
	hrv_title_wait_key: "Airdoc Stress Resilience Assessment",
	hrv_test_hook_finger_disconnected_key:
		"Please configure the finger collector",
	face_not_detected_mix_key:
		"Please align your face with the device and make sure there is sufficient light.Keep your face directly facing the device, don't cover your face, and make sure your face is shown in the middle of the frame.",
	face_not_detected_key:
		"Please align your face with the device and make sure there is sufficient light.",
	face_not_detected_key2:
		"Keep your face directly facing the device, don't cover your face, and make sure your face is shown in the middle of the frame.",
	face_too_small_key: "Please move closer to the screen.",
	face_too_close_to_edge_key:
		"Please adjust your position and make sure your face is shown in the middle of the frame.",
	face_multiple_detected_key: "Please keep the tester within the lens range, and other people leave.",
	face_too_large_key:
		"Please move further away from the screen and make sure your face is shown in the middle of the box.",
	hrv_stage1_key:
		"Please maintain a correct sitting posture. Observe the images displayed on the screen, which contain key signals and important information related to mental and psychological aspects. The assessment will last for 90 seconds.",
	hrv_stage2_key: "Please observe the picture carefully.",
	hrv_stage2_timeleft_key: "Total countdown:",
	seconds_key: "seconds",
	hrv_stage2_leftimage_key: "Please focus on the image on the left.",
	hrv_stage2_fps_key: "Video frame rate:",
	hrv_idnum: "ID number:",
	hrv_username: "Name:",
	hrv_gender: "Gender:",
	hrv_select_gender: "Please select gender",
	male_key: "Male",
	female_key: "Female",
	hrv_age_key: "Age:",
	hrv_select_age_key: "Please select age",
	start_key: "Start",
	model_initing_key: "Take a deep breath and calm down. Please wait...",
	report_generating_key: "The report is being generated. Please wait...",
	report_generate_exception_key:
		"Report generation exception. If you have already operated correctly according to the prompts, please contact the equipment administrator to check the equipment.",
	report_generate_complete_report_later_key:
		"The report has been generated. Please check it later.",
	exit_key: "Exit",
	username_key: "Name",
	gender_key: "Gender",
	age_key: "Age",
	idnum_key: "ID number",
	check_time_key: "Inspection time",
	adjust_by_tips_key: "Please make adjustments according to the prompts.",
	tips_key: "Tips",
	confirm_key: "Confirm",
	hrv_report_title_key: "Airdoc Stress Resilience Assessment Report",
	report_doctor_key: "Reporting physician",
	colon_key: ":",
	signature_key: "Signature",
	report_date_key: "Report date",
	date_key: "Date",
	report_hospital_seal: "Hospital seal",
	seal_key: "Seal",
	print_report_key: "Print report",
	return_key: "Return",
	cancel_key: "Cancel",
	hrv_finish_tip_scan:
		"Detection completed, please view the report on your mobile device.",
	hrv_finish_tip_input: "Detection completed.",
	hrv_finish_btn: "Confirm",
	hrv_back_btn: "Cancel",
	hrv_init_tips:
		"Please position your face directly in front of the device, ensuring your face is centered in the image, with adequate lighting and no obstructions.",
	hrv_init_ready: "Start",
	frequency_domain_analysis_key: "Frequency domain analysis chart",
	autonomic_nervous_analysis_key: "Autonomic nervous system assessment",
	stress_evaluation_key: "Stress state assessment",
	rr_interval_histogram_key: "RR interval distribution histogram",
	index_interpretation_report_key: "Index interpretation report",
	balance_autonomic_nervous_key: "Autonomic nerve balance",
	activity_autonomic_nervous_key: "Autonomic nerve activity",
	physical_pressure_key: "Physical stress",
	mental_pressure_key: "Psychological stress",
	stress_resistance_key: "Resilience capability",
	hrv_param_key: "Parameters for heart rate variability analysis",
	time_domain_param_key: "Parameters for time domain analysis",
	frequency_domain_param_key: "Parameters for frequency domain analysis",
	metric_key: "Indicator",
	figure_key: "Value",
	balance_detail_key:
		"# Autonomic nerve balance: Finding the best 'Speed and Passion' for your body and mind\n\n## Principle\nAutonomic nerve balance can be regarded as the 'acceleration and braking' system in your life. The sympathetic nerve is like an accelerator, helping you respond quickly in emergencies, while the parasympathetic nerve is like a brake, helping you return to calm after the stress has passed. When these two are in balance, you can face the challenges and opportunities in life in the best state.\n\n## Suggestions\n\n### Normal balance (50 - 70)\n* Keep doing moderate exercise, such as jogging, swimming or yoga, more than three times a week. These exercises will help you continue to stabilize your mood and make the acceleration and braking in life smoother and more enjoyable.\n* Although the current state is normal, various unexpected situations in life may quickly disrupt this balance.\n* To better maintain your physical and mental health, it is recommended that you use the TSC-102 Mental Health Multimodal Inspection Instrument to regularly monitor autonomic nerve activity and adjust your exercise plan in a timely manner. Meanwhile, using the TSL-102W Sunshine Treasure for light therapy can also further improve your emotional stability and help you create a healthier lifestyle. For more product information, please add the SoulHeal enterprise WeChat account to inquire about product prices and promote mental health.",
	activity_detail_key:
		"# Autonomic Nervous Activity: Making the Notes of Life Play the Best Melody\n\n\n## Principle\nImagine that your autonomic nervous activity is like the volume control of a stereo. If the volume is too high, it may be harsh and unbearable; if it is too low, you can't hear clearly and it will affect the experience. Only when it is adjusted to a moderate volume can you hear the most wonderful melody and experience the best state of life.\n\n\n## Suggestions\n\n\n### Normal Activity (50 - 70)\n* Keep your healthy lifestyle so that you can continue to play the wonderful melody of life and enjoy every pleasant moment.\n* Normal activity doesn't mean you can relax your vigilance. It's very important to stay alert and make moderate adjustments.\n* Regularly use the TSC-102 Mental Health Multimodal Tester to better grasp the changes in autonomic nervous activity and help you make timely adjustments. For more product information, please add the SoulHeal enterprise WeChat account to consult the product price and promote mental health.",
	physical_pressure_detail_key:
		"# Physical Stress: Keeping the 'Balloon' at an Appropriate Pressure\n\n\n## Principle\nPhysical stress can be regarded as the air in a balloon. An appropriate amount of pressure will keep the balloon in good shape, but if it is inflated too much, the balloon is at risk of bursting at any time. The same is true for your body. Moderate stress can stimulate potential, but excessive stress can cause harm.\n\n\n## Suggestions\n\n\n### Normal Pressure (40 - 60)\n* Keep your current living habits and moderate exercise to keep your physical stress in the'safe zone', full of energy but not overly tense.\n* The normal pressure level may change rapidly due to changes in the external environment, so be prepared to cope with various changes.\n* Use the TSC-102 Mental Health Multimodal Tester for regular monitoring to ensure the stability of physical stress. For more product information, please add the SoulHeal enterprise WeChat account to consult the product price and promote mental health.",
	mental_pressure_detail_key:
		"# Psychological Stress: Keeping the 'Water Level of the Mind' at an Ideal Height\n\n\n## Principle\nPsychological stress can be compared to the water level in the mind. A moderate water level can nourish your mind, but when the water level is too high, it may overflow and affect your emotions and life. Your goal is to make this'mind lake' full of vitality without flooding.\n\n\n## Suggestions\n\n\n### Normal Pressure (30 - 50)\n* Continue to cultivate hobbies and participate in social activities to keep your mind lake at a healthy water level and make it always full of vitality.\n* Even if it is currently within the normal range, various life challenges may easily disrupt this balance.\n* Use the TSC-102 Mental Health Multimodal Tester to regularly conduct psychological monitoring so as to grasp the changes in your psychological state in a timely manner. For more product information, please add the SoulHeal enterprise WeChat account to consult the product price and promote mental health.",
	stress_resistance_detail_key:
		"# Resilience Capability: Building a Solid 'Psychological Bridge'\n\n\n## Principle\nResilience capability can be compared to the load-bearing capacity of a bridge. The stronger the bridge, the more weight it can bear without collapsing. You are the architect of your own life, building a solid bridge that can withstand all challenges.\n\n\n## Suggestions\n\n\n### Normal Resilience Capability (50 - 70)\n* Strengthen your social support system through social activities, learn new interest skills, and make this bridge more solid to prepare for every future challenge.\n* Although the resilience capability is at a normal level, it still needs to be improved to better cope with possible future challenges.\n* Use the TSC-102 Mental Health Multimodal Tester to monitor resilience capability and understand your mental health level. For more product information, please add the SoulHeal enterprise WeChat account to consult the product price and promote mental health.",
	emotion_title_key: "Expression Analysis",
	emotion_sys_desc_key: "Introduction to the Expression Analysis System",
	emotion_sys_welcome_key:
		"Welcome to our Expression Analysis System. This powerful tool utilizes the latest deep learning technology to provide you with precise emotion recognition.",
	emotion_sys_welcome_key1:
		'Please face the device directly with your face and click the "Start" button below.',
	emotion_sys_desc1_key:
		"Expression analysis is based on advanced deep learning models and can accurately identify multiple emotional states.",
	emotion_sys_desc2_key:
		"By default, the system captures one frame of image for analysis every 5 seconds and automatically generates a comprehensive report after capturing 3 frames.",
	emotion_sys_desc3_key:
		"In the field of mental health, expression analysis has a wide range of applications:",
	emotion_sys_desc3_li1_key:
		"Assist psychologists in better understanding the emotional changes of patients.",
	emotion_sys_desc3_li2_key:
		"Provide objective data support for the emotion recognition training of autistic patients.",
	emotion_sys_desc3_li3_key:
		"Help evaluate the emotional state of depression patients and assist in the treatment process.",
	emotion_sys_desc3_li4_key:
		"In remote mental health services, provide real-time emotional feedback to enhance the treatment effect.",
	emotion_sys_pre_start_key:
		'Ready to start exploring your emotional world? Click the "Start" button below to embark on your expression analysis journey!',
	finish_key: "Finish",
	emotion_report_title_key: "Mental Health Emotional State Assessment Report",
	evaluation_date_key: "Evaluation Date",
	evaluation_method_key: "Evaluation Method",
	report_number_key: "Report Number",
	emotion_sys_ai_key: "AI Emotion Recognition System",
	emotion_report_section1_key: "I. Assessment Overview",
	dear_key: "Dear",
	emotion_report_section1_desc_key:
		"This report uses advanced emotion recognition technology to help us better understand your emotional state. This technology is like a careful observer that can capture your emotional changes and help us find ways to improve mental health together.",
	emotion_report_section2_key: "II. Analysis of Emotional State",
	emotion_report_section2_h3_key: "1. Emotional Arousal",
	emotion_report_section2_h3_desc1_key: "Your emotional arousal is shown as",
	emotion_report_section2_h3_desc2_key:
		"level, which represents your emotional energy level. Just like the engine speed of a car:",
	emotion_report_section2_h3_li1_key:
		"High arousal: Like the engine running at high speed",
	emotion_report_section2_h3_li2_key: "Low arousal: Like the engine idling",
	emotion_report_section2_h3_2_key: "2. Emotional Valence",
	emotion_report_section2_h3_2_desc1_key: "Your emotional valence presents",
	emotion_report_section2_h3_2_desc2_key:
		"characteristics, which reflects the color of your emotions. It can be understood as:",
	emotion_report_section2_h3_2_li1_key: "Positive: Like a sunny day",
	emotion_report_section2_h3_2_li2_key:
		"Negative: Like a rainy and overcast day",
	emotion_report_section2_h3_3_key: "3. Main Emotional Distribution",
	emotion_report_section2_h3_3_xy1_key:
		"Quadrant I (High Arousal - Positive)",
	emotion_report_section2_h3_3_xy1_desc1_key:
		"Emotional expressions: Excitement, Joy",
	emotion_report_section2_h3_3_xy1_desc2_key: "Typical scenarios:",
	emotion_report_section2_h3_3_xy1_desc2_li1_key:
		"Feeling happy and excited in social activities",
	emotion_report_section2_h3_3_xy1_desc2_li2_key:
		"A sense of accomplishment when achieving work goals",
	emotion_report_section2_h3_3_xy1_desc2_li3_key:
		"Being energetic after sports or physical activities",
	emotion_report_section2_h3_3_xy1_desc2_li4_key:
		"Joy when receiving good news",
	emotion_report_section2_h3_3_xy1_desc2_li5_key:
		"Happiness when reuniting with family and friends",
	emotion_report_section2_h3_3_xy2_key:
		"Quadrant II (High Arousal - Negative)",
	emotion_report_section2_h3_3_xy2_desc1_key:
		"Emotional expressions: Tension, Anxiety",
	emotion_report_section2_h3_3_xy2_desc2_li1_key:
		"Anxiety due to high work/study pressure",
	emotion_report_section2_h3_3_xy2_desc2_li2_key:
		"Anger after interpersonal conflicts",
	emotion_report_section2_h3_3_xy2_desc2_li3_key:
		"Nervousness before important events",
	emotion_report_section2_h3_3_xy2_desc2_li4_key:
		"Panic caused by unexpected events",
	emotion_report_section2_h3_3_xy2_desc2_li5_key:
		"Restlessness when waiting for important results",
	emotion_report_section2_h3_3_xy3_key:
		"Quadrant III (Low Arousal - Negative)",
	emotion_report_section2_h3_3_xy3_desc1_key:
		"Emotional expressions: Tiredness, Depression",
	emotion_report_section2_h3_3_xy3_desc2_li1_key:
		"Fatigue after the end of a workday",
	emotion_report_section2_h3_3_xy3_desc2_li2_key: "Lethargy after insomnia",
	emotion_report_section2_h3_3_xy3_desc2_li3_key:
		"Frustration when plans are hindered",
	emotion_report_section2_h3_3_xy3_desc2_li4_key:
		"Feeling of loneliness when alone",
	emotion_report_section2_h3_3_xy3_desc2_li5_key:
		"Depression affected by rainy weather",
	emotion_report_section2_h3_3_xy4_key:
		"Quadrant IV (Low Arousal - Positive)",
	emotion_report_section2_h3_3_xy4_desc1_key:
		"Emotional expressions: Calmness, Relaxation",
	emotion_report_section2_h3_3_xy4_desc2_li1_key:
		"Calmness after waking up in the morning",
	emotion_report_section2_h3_3_xy4_desc2_li2_key:
		"Peacefulness when taking a deep breath to relax",
	emotion_report_section2_h3_3_xy4_desc2_li3_key:
		"Comfort when taking a warm bath",
	emotion_report_section2_h3_3_xy4_desc2_li4_key:
		"Tranquility when doing meditation",
	emotion_report_section2_h3_3_xy4_desc2_li5_key:
		"Serenity when enjoying nature",
	emotion_report_section3_key: "III. Personalized Suggestions",
	emotion_report_section3_key_desc1:
		"(Based on the guidelines of the American Psychological Association (APA) and the recommendations of the National Institutes of Health (NIH) of the United States)",
	emotion_report_section3_key_desc2_1: "1. Daily Regulation Suggestions",
	emotion_report_section3_key_desc2_1_a: "a) Sleep Management",
	emotion_report_section3_key_desc2_1_a_li1:
		"Maintain a fixed bedtime, preferably between 22:00 and 23:00",
	emotion_report_section3_key_desc2_1_a_li2:
		"Avoid using electronic devices 1 hour before going to bed",
	emotion_report_section3_key_desc2_1_a_li3:
		"Keep the bedroom temperature between 18℃ and 22℃",
	emotion_report_section3_key_desc2_1_a_li4:
		'Use the "5-4-3-2-1" sensory relaxation method to fall asleep',
	emotion_report_section3_key_desc2_1_b: "b) Exercise Suggestions",
	emotion_report_section3_key_desc2_1_b_li1:
		"Engage in 150 minutes of moderate-intensity aerobic exercise per week",
	emotion_report_section3_key_desc2_1_b_li2:
		"Recommendations: Walking, Swimming, Yoga",
	emotion_report_section3_key_desc2_1_b_li3:
		"Each exercise session should last 20 - 30 minutes",
	emotion_report_section3_key_desc2_1_b_li4:
		"It is best to exercise in the morning or afternoon, and avoid strenuous exercise in the evening",
	emotion_report_section3_key_desc2_1_c: "c) Dietary Adjustment",
	emotion_report_section3_key_desc2_1_c_li1:
		"Increase the intake of Omega-3 fatty acids (fish, nuts)",
	emotion_report_section3_key_desc2_1_c_li2:
		"Ensure an adequate daily water intake (1.5 - 2L)",
	emotion_report_section3_key_desc2_1_c_li3:
		"Limit caffeine intake, preferably consumed before 2 pm",
	emotion_report_section3_key_desc2_1_c_li4:
		"Add foods rich in tryptophan (bananas, turkey)",
	emotion_report_section3_key_desc2_1_d: "d) Social Activities",
	emotion_report_section3_key_desc2_1_d_li1:
		"Arrange 2 - 3 face-to-face social interactions per week",
	emotion_report_section3_key_desc2_1_d_li2:
		"Participate in interest groups or volunteer activities",
	emotion_report_section3_key_desc2_1_d_li3:
		"Maintain 15 minutes of high-quality conversation with family members every day",
	emotion_report_section3_key_desc2_1_d_li4:
		"Build a supportive social circle",
	emotion_report_section3_key_desc2_2: "2. Professional Support Suggestions",
	emotion_report_section3_key_desc2:
		"(Based on the guidelines of the American Psychiatric Association (APA))",
	emotion_report_section3_key_desc2_2_a: "a) Psychological Counseling",
	emotion_report_section3_key_desc2_2_a_li1: "It is recommended to attend",
	emotion_report_section3_key_desc2_2_a_li2:
		"It is recommended to have a 45 - 50 minute individual consultation once a week",
	emotion_report_section3_key_desc2_2_a_li3:
		"Choose Cognitive Behavioral Therapy (CBT) or Mindfulness-Based Cognitive Therapy (MBCT)",
	emotion_report_section3_key_desc2_2_a_li4:
		"Participate in group therapy once every two weeks",
	emotion_report_section3_key_desc2_2_a_li5: "Keep a therapy log",
	emotion_report_section3_key_desc2_2_b: "b) Relaxation Techniques",
	emotion_report_section3_key_desc2_2_b_li1:
		"Conduct progressive muscle relaxation training (15 minutes per day)",
	emotion_report_section3_key_desc2_2_b_li2:
		"Practice the 4-7-8 breathing method (3 times a day, 4 rounds each time)",
	emotion_report_section3_key_desc2_2_b_li3:
		"Mindfulness meditation (10 minutes each in the morning and evening)",
	emotion_report_section3_key_desc2_2_b_li4:
		"Use guided imagery (it is recommended to use a professional APP for assistance)",
	emotion_report_section3_key_desc2_2_c: "c) Medical Guidance",
	emotion_report_section3_key_desc2_2_c_li1:
		"Conduct a monthly follow-up of emotional assessment",
	emotion_report_section3_key_desc2_2_c_li2:
		"Consider drug treatment evaluation if necessary",
	emotion_report_section3_key_desc2_2_c_li3:
		"Regularly conduct physical examinations to exclude physical diseases",
	emotion_report_section3_key_desc2_2_c_li4:
		"Establish a crisis intervention plan",
	emotion_report_section4_key: "IV. Progress and Room for Improvement",
	emotion_report_section4_key_1: "1. Positive Changes",
	emotion_report_section4_key_1_li1:
		"Enhanced emotion recognition ability (able to accurately name the current emotion)",
	emotion_report_section4_key_1_li2:
		"Strengthened self-regulation skills (able to use breathing methods to relieve anxiety)",
	emotion_report_section4_key_1_li3:
		"Improved interpersonal relationships (actively seeking social support)",
	emotion_report_section4_key_1_li4:
		"Enhanced sleep quality (shorter sleep onset time and more continuous sleep)",
	emotion_report_section4_key_1_li5:
		"Increased work efficiency (able to better manage stress)",
	emotion_report_section4_key_2: "2. Areas Needing Attention",
	emotion_report_section4_key_2_li1:
		"Amplitude of emotional fluctuations (it is recommended to keep an emotion diary to identify triggering factors)",
	emotion_report_section4_key_2_li2:
		"Stress tolerance (learn more stress reduction techniques)",
	emotion_report_section4_key_2_li3:
		"Quality of social interaction (cultivate deep interpersonal relationships)",
	emotion_report_section4_key_2_li4:
		"Self-care awareness (increase the quality time of being alone)",
	emotion_report_section4_key_2_li5:
		"Regularity of daily routine (establish a more stable daily routine)",
	emotion_report_section5_key: "V. Follow-up Plan",
	emotion_report_section5_key_1: "1. Short-term Goals (1-2 weeks)",
	emotion_report_section5_key_1_a: "a) Emotion Management",
	emotion_report_section5_key_1_a_li1:
		"Record your emotional state and triggering events three times a day.",
	emotion_report_section5_key_1_a_li2:
		"Learn and practice one new relaxation technique.",
	emotion_report_section5_key_1_a_li3:
		"Develop a habit of taking deep breaths for 5 minutes in the morning and evening.",
	emotion_report_section5_key_1_b: "b) Lifestyle Habits",
	emotion_report_section5_key_1_b_li1:
		"Keep a regular schedule and fixed sleeping hours.",
	emotion_report_section5_key_1_b_li2:
		"Spend 15 minutes on outdoor activities every day.",
	emotion_report_section5_key_1_b_li3:
		"Reduce the time spent on social media to within 1 hour.",
	emotion_report_section5_key_1_c: "c) Social Activities",
	emotion_report_section5_key_1_c_li1:
		"Have an in-depth conversation with a friend once a week.",
	emotion_report_section5_key_1_c_li2:
		"Participate in a group activity or an interest group once.",
	emotion_report_section5_key_1_c_li3: "Practice active listening skills.",
	emotion_report_section5_key_2: "2. Mid-term Goals (1-3 months)",
	emotion_report_section5_key_2_a: "a) Psychological Building",
	emotion_report_section5_key_2_a_li1:
		"Complete an 8-week mindfulness course.",
	emotion_report_section5_key_2_a_li2:
		"Establish a stable emotional support system.",
	emotion_report_section5_key_2_a_li3:
		"Master 3-5 effective stress management strategies.",
	emotion_report_section5_key_2_b: "b) Behavior Change",
	emotion_report_section5_key_2_b_li1:
		"Form a regular exercise habit (3-4 times a week).",
	emotion_report_section5_key_2_b_li2: "Establish a healthy diet pattern.",
	emotion_report_section5_key_2_b_li3: "Develop a new hobby.",
	emotion_report_section5_key_2_c: "c) Interpersonal Relationships",
	emotion_report_section5_key_2_c_li1:
		"Improve the family communication pattern.",
	emotion_report_section5_key_2_c_li2: "Expand your social circle.",
	emotion_report_section5_key_2_c_li3:
		"Learn to set healthy interpersonal boundaries.",
	emotion_report_section6_key: "VI. Kind Reminders",
	emotion_report_section6_key_li1:
		"Emotional fluctuations are normal, just as natural as the changes in the weather.",
	emotion_report_section6_key_li2:
		"Be patient, as change is a gradual process.",
	emotion_report_section6_key_li3:
		"It's wise and brave to seek professional help at any time.",
	emotion_report_section7_key: "VII. Emergency Contact Information",
	emotion_report_section7_key_li1:
		"24-hour Psychological Assistance Hotline:",
	emotion_report_section7_key_li2:
		"Contact Information of the Attending Physician:",
	emotion_report_section7_key_li3: "Nearest First Aid Center:",
	emotion_report_section8_key: "VIII. References",
	emotion_report_section8_key_p1:
		"The Authoritative Guidelines on Mental Health Assessment by the World Health Organization",
	emotion_report_section8_key_p2:
		"Diagnostic and Statistical Manual of Mental Disorders, the gold standard for emotion assessment",
	emotion_report_section8_key_p3:
		"The Latest Progress in Research on Mood Disorders Released by the National Institute of Mental Health",
	emotion_report_section8_key_p4:
		"Classic Works on the Treatment of Mood Disorders",
	emotion_report_section8_key_p5:
		"Application Guidelines for Dialectical Behavior Therapy in Emotion Regulation",
	emotion_report_notes_key: "Precautions:",
	emotion_report_notes_key_li1:
		"This report is for reference only and cannot replace the diagnostic opinions of professional doctors.",
	emotion_report_notes_key_li2:
		"If you feel continuously depressed or have other discomforts, please seek medical treatment in time.",
	emotion_report_notes_key_li3:
		'Everyone\'s emotional pattern is unique, and there is no need to overly pursue the "standard" state.',
	emotion_valence_positive_key: "Positive",
	emotion_valence_negative_key: "Negative",
	emotion_arousal_high_key: "High Arousal",
	emotion_arousal_low_key: "Low Arousal",
	emotion_va_analyze_key: "Valence-Arousal Analysis",
	emotion_analyze_result_key: "Emotion Analysis Result:",
	sad_key: "Sadness",
	happy_key: "Happiness",
	surprise_key: "Surprise",
	fear_key: "Fear",
	disgust_key: "Disgust",
	anger_key: "Anger",
	neutral_key: "Neutral",
	neglect_key: "Neglect",
	speech_sys_title_key: "Speech Emotion Analysis",
	speech_sys_desc_key: "Introduction to the Speech Emotion Analysis System",
	speech_sys_desc_welcome_key:
		"Welcome to use our speech analysis system. This powerful tool utilizes the latest deep learning technologies to provide you with accurate emotion recognition.",
	speech_sys_desc_li1_key:
		"The speech analysis is based on advanced deep learning models and can accurately identify multiple emotional states.",
	speech_sys_desc_pre_start_key:
		"Are you ready to start exploring your emotional world? Click the 'Start' button below to embark on your speech analysis journey!",
	speech_sys_desc_welcome_key1:
		'Please click the "Start Recording" button below and improvise a recording of your voice, which should be between 10 and 30 seconds.',
	speech_sys_desc_welcome_key2:
		'Please click "Submit" after the recording is completed.',
	recording_key: "Recording...",
	record_action_key: "Record",
	speech_sys_denoise_key:
		"Noise Reduction (Do not check this box unless the environment is noisy)",
	stop_recording_key: "Stop Recording",
	start_recording_key: "Start Recording",
	pause_key: "Pause",
	play_key: "Play",
	speech_sys_vioce_analyze_key: "Submit",
	speech_sys_noaccess_mic_key: "No access to the microphone",
	speech_sys_warning_recording_key: "Please record the audio first.",
	speech_sys_analyze_failed_key: "Failed to analyze the speech",
	speech_report_title_key:
		"Mental Health Speech Emotion State Evaluation Report",
	speech_report_section1_key: "I. Evaluation Overview",
	speech_report_section1_key_desc:
		"This evaluation adopted advanced speech emotion recognition technology. By analyzing your speech features, including dimensions such as pitch, speech rate, volume, and speech texture, a comprehensive quantitative analysis of your emotional state was conducted. The evaluation results show your current overall emotional state.",
	speech_report_section2_key: "II. Emotional State Analysis",
	speech_report_section2_key_1: "1. Overview of Emotion Distribution",
	speech_report_section2_key_1_h1: "Positive Emotions (Total)",
	speech_report_section2_key_1_h2: "Neutral Emotions",
	speech_report_section2_key_1_h3: "Negative Emotions (Total)",
	speech_report_section2_key_2: "2. Emotion Feature Analysis",
	speech_report_section2_key_2_h1: "Emotion Activity",
	speech_report_section2_key_2_h2: "Emotion Valence",
	speech_report_section3_key: "III. Personalized Suggestions",
	speech_report_section3_key_1: "1. Positive Reinforcement",
	speech_report_section3_key_1_a: "a) Maintaining Positive Emotions",
	speech_report_section3_key_1_a_li1:
		"Positive lifestyle and activity patterns",
	speech_report_section3_key_1_a_li2:
		"Record daily activities that bring a sense of happiness",
	speech_report_section3_key_1_a_li3: "Establish a positive emotion diary",
	speech_report_section3_key_1_a_li4:
		"Cultivate a sense of gratitude and record three things to be grateful for every day.",
	speech_report_section3_key_1_b: "b) Maintaining Emotional Stability",
	speech_report_section3_key_1_b_li1: "Keep a regular daily routine",
	speech_report_section3_key_1_b_li2:
		"Set fixed exercise and relaxation times",
	speech_report_section3_key_1_b_li3: "Maintain healthy social activities",
	speech_report_section3_key_1_b_li4:
		"Cultivate the habit of mindfulness and meditate for 10 - 15 minutes every day.",
	speech_report_section3_key_2: "2. Improvement Suggestions",
	speech_report_section3_key_2_a: "a) Richness of Emotion Expression",
	speech_report_section3_key_2_a_li1:
		"Practice expressing different emotions in a safe social environment",
	speech_report_section3_key_2_a_li2: "Expand the emotion vocabulary library",
	speech_report_section3_key_2_a_li3:
		"Improve the accuracy of emotion recognition",
	speech_report_section3_key_2_a_li4:
		"Participate in emotion expression workshops or courses",
	speech_report_section3_key_2_b: "b) Stress Management Skills",
	speech_report_section3_key_2_b_li1:
		"Learn scientific stress management methods",
	speech_report_section3_key_2_b_li2:
		"Establish healthy stress release channels",
	speech_report_section3_key_2_b_li3: "Cultivate positive hobbies",
	speech_report_section3_key_2_b_li4: "Build a supportive social network",
	speech_report_section4_key: "IV. Follow-up Plan",
	speech_report_section4_key_1: "1. Short-term Goals (1 - 2 weeks)",
	speech_report_section4_key_1_a: "a) Emotional Awareness",
	speech_report_section4_key_1_a_li1: "Record three happy moments every day",
	speech_report_section4_key_1_a_li2:
		"Use an emotion tracking app to record changes in emotions",
	speech_report_section4_key_1_a_li3:
		"Practice recognizing subtle changes in emotions",
	speech_report_section4_key_1_a_li4:
		"Establish the habit of keeping an emotion diary",
	speech_report_section4_key_1_b: "b) Lifestyle Habits",
	speech_report_section4_key_1_b_li1: "Keep a regular routine",
	speech_report_section4_key_1_b_li2:
		"Do aerobic exercise for 15 - 30 minutes every day",
	speech_report_section4_key_1_b_li3:
		"Ensure 7 - 8 hours of sufficient sleep",
	speech_report_section4_key_1_b_li4: "Cultivate a new hobby",
	speech_report_section4_key_2: "2. Medium-term Goals (1 - 3 months)",
	speech_report_section4_key_2_a: "a) Ability Improvement",
	speech_report_section4_key_2_a_li1:
		"Participate in emotion management workshops",
	speech_report_section4_key_2_a_li2: "Learn 2 - 3 relaxation techniques",
	speech_report_section4_key_2_a_li3: "Master basic meditation methods",
	speech_report_section4_key_2_a_li4:
		"Improve communication and expression abilities",
	speech_report_section4_key_2_b: "b) Social Development",
	speech_report_section4_key_2_b_li1:
		"Participate in group activities 1 - 2 times a week",
	speech_report_section4_key_2_b_li2:
		"Deepen existing friendship relationships",
	speech_report_section4_key_2_b_li3: "Expand the social circle",
	speech_report_section4_key_2_b_li4:
		"Improve the quality of interpersonal interaction",
	speech_report_section5_key: "V. Precautions",
	speech_report_section5_key_li1:
		"Maintain the current positive emotional state, but avoid excessive excitement.",
	speech_report_section5_key_li2:
		"Accept the natural fluctuations of emotions and don't pursue always positive emotions.",
	speech_report_section5_key_li3:
		"Conduct regular emotional state evaluations. It is recommended to do so once a month.",
	speech_report_section5_key_li4:
		"If there are significant fluctuations in emotions, seek professional support in a timely manner.",
	speech_report_section6_key: "VI. References",
	speech_report_section6_key_p1:
		"Authoritative Research on Speech Emotion Recognition",
	speech_report_section6_key_p2:
		"Review of the Development of Speech Emotion Analysis",
	speech_report_section6_key_p3:
		"Latest Advances in Speech Affective Computing",
	speech_report_section7_key: "VII. Emergency Contact Information",
	speech_report_section7_key_li1: "24-hour Psychological Assistance Hotline:",
	speech_report_section7_key_li2:
		"Contact Information of the Attending Physician:",
	speech_report_section7_key_li3: "Nearest Emergency Center:",
	surprised_happy_key: "Surprise",
	hrv_report_score: "Score",
	suggestion: "Suggestions",
	exceed_percentage_key: "Exceeds {num}% of peers",
	better_than_percentage_key: "Better than {num}% of peers",
	// HRV Store related translations
	hrv_store_data_incomplete: "Data incomplete, cannot submit",
	hrv_store_http_error: "HTTP Error: {status}",
	hrv_store_user_expired: "User expired",
	hrv_store_submit_failed: "Submit failed",
	hrv_store_request_timeout: "Request timeout",
	hrv_store_network_error: "Network error: {status}",
	hrv_store_unknown_error: "Unknown error",
	hrv_report_data_empty: "No report data available",
	retry_key: "Retry",
	hrv_report_v2: {
		font_size_standard: "Standard",
		font_size_medium: "Medium",
		font_size_large: "Large",
		download_pdf: "Download PDF",
		what_is_it: "What is it",
		why: "Why",
		what_to_do: "What to do",
		info_page_title: "{title} Details",
		current: "Current",
		low: "Low",
		medium: "Medium",
		medium_bottom: "Below Average",
		medium_top: "Above Average",
		medium_low: "Moderately Low",
		medium_high: "Moderately High",
		high: "High",
		strong: 'strong',
		weak: 'weak',
		lower: "Low",
		good: "Good",
		higher: "Hight",
		normal: 'Normal',
		comprehensive_advice: "Comprehensive Advice",
		next_check_date: "Suggested Next Check Date",
		doctor: "Doctor",
		date: "Date",
		index_interpretation: "Interpretation",
		trend_analysis: "Trend Analysis",
		health_advice: "Health Life Plan",
		trend_chart_point_text: "Please check in on time",
		assessment: "Assessment",
		current_assessment: "Current Assessment",
		hotline: "Hotline",
		name: "Name",
		gender: "Gender",
		male: "Male",
		female: "Female",
		age: "Age",
		id_number: "ID Number",
		time: "Time",
		page: "",
		page_suffix: "",
		// HeadsetPage related translations
		gaba_rx_title: "GABA Rx Smart Wearable",
		usage_suggestion_title: "Usage Tips",
		tavns_title: "taVNS Auricular Vagus Nerve Stimulation",
		gaba_rx_description_part1: "Using ",
		gaba_rx_description_tech: "auricular vagus nerve stimulation (taVNS)",
		gaba_rx_description_part2: "——gentle electrical pulses to ear vagus nerve areas, with music and breathing guidance,",
		gaba_rx_description_highlight: "helps regulate autonomic function, improve sleep, and reduce anxiety and stress.",
		recommended_scenarios: "Usage Scenarios",
		scenario_1: 'Active mind at night causing insomnia despite fatigue.',
		scenario_2: 'Post-work mental fog with overactive nerves.',
		scenario_3: "Unexplained anxiety, overthinking, chest tightness.",
		scenario_4: "Afternoon sleepiness but can't nap.",
		scenario_5: "Exhausted but can't reach deep sleep, anxious.",
		scenario_6: "Stress overload, sleepless nights, morning fatigue.",
		scientific_background: "Science Background",
		scientific_background_desc: "taVNS is non-invasive neuromodulation. Earphone stimulation of auricular vagus nerve activates brain vagus network, restoring autonomic balance.",
		core_mechanism: "Core Mechanism",
		stimulation_parameters: "20Hz low-frequency pulses on auricular vagus terminals.",
		regulation_effect: 'Activates parasympathetic system, inhibits overactive sympathetic nerves, restores mind-body balance.',
		physiological_effects: "Effects",
		physiological_effects_desc: 'Research shows taVNS quickly activates parasympathetic system, promotes relaxation, relieves stress, enhances emotional regulation and cognition. Minutes of stimulation enables natural relaxation and recovery.'

	},
}
